import React, { useState, useEffect } from 'react';
import useGlobal from '../../store';


const AvatarUploader = (props) => {
    
    const [imgUrl, setImgUrl] = useState(typeof props.avatar === "string" ? props.avatar : props.avatar.props.src);

    const [response, userActions] = useGlobal(
        state => state.response,
        actions => actions.userActions
    );
    
    //const [file, setFile] = useState(props.isBought);

    const handleFileInputChange = (event) => {
        const f = event.target.files[0];
        console.log('NEW FILE', f);
        //setFile(f);
        uploadHandler(f);
    }

    const uploadHandler = (file) => {
        const formData = new FormData();
        console.log('NEW FILE 2', file, file.name);
        formData.append(
            'file',
            file,
            file.name
        );
        userActions.uploadAvatar(formData, props.userID);
    }

    useEffect(() => {
        if(!response || response.type !== "avatarupload" || !response.data.success) {
            return;
        }
        let newImgUrl = "https://weblight.imgix.net/avatars/"+ response.data.success + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2";
        setImgUrl(newImgUrl);
    }, [response])

    return (
        <>
        { imgUrl !== "" ?  <img src={imgUrl} alt="" />
            : <div className="kt-media kt-media--xl kt-media--circle kt-media--info">
            <span>{props.FirstName ? props.FirstName.charAt(0) : '?'}{props.LastName ? props.LastName.charAt(0) : ''}</span>
        </div> }
        <label className="kt-profile__main-pic-upload">
            <i className="flaticon-photo-camera"></i>
            <input type="file" name="profile_avatar" onChange={handleFileInputChange} accept=".png, .jpg, .jpeg"></input>
        </label>
    </>);
}
export default AvatarUploader;